import { mobileIosPlatforms, mobileRegExp, userAgentMac } from './constants'

export const getIsMobileDevice = (): boolean => mobileRegExp.test(window.navigator.userAgent)

export const getIsMobileIos = (): boolean => {
	return (
		mobileIosPlatforms.includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes(userAgentMac) && 'ontouchend' in document)
	)
}
